import React from 'react';
import { Container } from 'reactstrap';

//redux
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import ReportTemplateList from './ReportTemplateList';

const ReportTemplate = () => {
	const breadcrumbLinks = [{ to: '#', label: 'Inicio' }];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Plantillas de reporte' links={breadcrumbLinks} />
					<ReportTemplateList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default ReportTemplate;